import { render } from "./queModel.vue?vue&type=template&id=1dd4c9b4"
import script from "./queModel.vue?vue&type=script&lang=js"
export * from "./queModel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__